"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.strategy = void 0;
const lodash_1 = __importDefault(require("lodash"));
exports.strategy = (strategy) => __awaiter(void 0, void 0, void 0, function* () {
    const { params, addresses } = strategy;
    const paramAddress = params.addresses.map(address => address.toLowerCase());
    const addressesToCompare = addresses.map(address => address.toLowerCase());
    var presents = lodash_1.default.intersectionWith(paramAddress, addressesToCompare, lodash_1.default.isEqual);
    const isAuthorized = presents.length > 0;
    const message = presents.length > 0 ? 'Your wallet is authorized' : 'Your wallet is not authorized';
    const code = isAuthorized ? 0 /* SUCCESS */ : 1 /* NOTENOUGH */;
    return {
        isAuthorized,
        strategy: strategy,
        message: message,
        code
    };
});
//# sourceMappingURL=index.js.map